import { render, staticRenderFns } from "./elsebusiness.vue?vue&type=template&id=10ebeab6&scoped=true&"
import script from "./elsebusiness.vue?vue&type=script&lang=js&"
export * from "./elsebusiness.vue?vue&type=script&lang=js&"
import style0 from "./elsebusiness.vue?vue&type=style&index=0&id=10ebeab6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ebeab6",
  null
  
)

export default component.exports